export default "__VITE_ASSET__Cyt$3Dx9__"